import { render, staticRenderFns } from "./realnameUser.vue?vue&type=template&id=19394180&scoped=true&"
import script from "./realnameUser.vue?vue&type=script&lang=js&"
export * from "./realnameUser.vue?vue&type=script&lang=js&"
import style0 from "./realnameUser.vue?vue&type=style&index=0&id=19394180&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19394180",
  null
  
)

export default component.exports